function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import { ChevronDownIcon, ChevronUpIcon } from '@domain-group/fe-co-icon';
import { getImageUrl, AllImageSizes } from '@domain-group/fe-allhomes-library';
import * as styles from './single-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PropertyHistoryCard = /*#__PURE__*/forwardRef((props, ref) => {
  var _useState = useState(props.isExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(props.disableExpand),
    _useState4 = _slicedToArray(_useState3, 2),
    disableExpand = _useState4[0],
    setDisableExpand = _useState4[1];

  // side-effect to update isExpanded state
  useEffect(() => {
    setIsExpanded(props.isExpanded);
  }, [props.isExpanded]);

  // side-effect to update disableExpand
  useEffect(() => {
    setDisableExpand(props.disableExpand);
  }, [props.disableExpand]);
  return ___EmotionJSX("div", {
    css: styles.singleCard(isExpanded),
    className: props.className,
    role: "button",
    tabIndex: "0",
    onKeyDown: () => {},
    ref: ref,
    onClick: () => {
      if (!disableExpand && !isExpanded && props.media.mobile) {
        // we do not collapse clicking anywhere on the card
        // to prevent confusion as we have other clickable items.
        // e.g, photos. User can collapse the card by clicking chevron.
        props.onExpand();
        setIsExpanded(true);
      }
    }
  }, ___EmotionJSX("div", {
    css: styles.containerInner
  }, ___EmotionJSX("div", {
    css: styles.date
  }, props.date), ___EmotionJSX("div", {
    css: styles.title
  }, props.title), ___EmotionJSX("div", {
    css: styles.agencyName
  }, props.agencyName), ___EmotionJSX("div", {
    css: styles.hiddenDetails(isExpanded)
  }, ___EmotionJSX("div", {
    css: styles.price
  }, props.price), ___EmotionJSX("div", {
    css: styles.detailItems
  }, Object.keys(props.details).filter(item => props.details[item]).map(item => ___EmotionJSX("div", {
    key: item,
    css: styles.detailItem
  }, item, ": ", props.details[item]))))), isExpanded && props.photos.length > 0 && ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.photos
  }, props.photos.filter((_, idx) => idx < 4).map((photo, idx) => ___EmotionJSX("button", {
    key: photo.imageSrc,
    type: "button",
    css: styles.photoItem,
    onClick: () => {
      if (disableExpand) {
        return;
      }
      props.onPhotoClick(props.photos, idx);
    }
  }, ___EmotionJSX("img", {
    src: getImageUrl(photo.imageSrc, AllImageSizes.MEDIUM),
    alt: photo.title,
    title: photo.title,
    css: styles.photoImg
  })))), ___EmotionJSX("button", {
    css: styles.photoButton,
    type: "button",
    onClick: () => {
      if (disableExpand) {
        return;
      }
      props.onPhotoClick(props.photos, 0);
    }
  }, "All photos (", props.photos.length, ")")), ___EmotionJSX("button", {
    css: styles.expandButton,
    type: "button",
    onClick: () => {
      if (disableExpand) {
        return;
      }
      if (isExpanded) {
        // collapsing
        props.onCollapse();
        setIsExpanded(false);
      } else {
        props.onExpand();
        setIsExpanded(true);
      }
    }
  }, isExpanded && ___EmotionJSX(ChevronUpIcon, {
    css: styles.chevronIcon,
    size: "custom"
  }), !isExpanded && ___EmotionJSX(ChevronDownIcon, {
    css: styles.chevronIcon,
    size: "custom"
  })));
});
PropertyHistoryCard.propTypes = {
  isExpanded: PropTypes.bool,
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  agencyName: PropTypes.string,
  className: PropTypes.string,
  price: PropTypes.string.isRequired,
  details: PropTypes.object.isRequired,
  // eslint-disable-line
  photos: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    imageSrc: PropTypes.string,
    order: PropTypes.number,
    type: PropTypes.string
  })),
  onPhotoClick: PropTypes.func,
  onExpand: PropTypes.func,
  onCollapse: PropTypes.func,
  media: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  disableExpand: PropTypes.bool
};
PropertyHistoryCard.defaultProps = {
  isExpanded: false,
  agencyName: 'Unknown',
  className: '',
  photos: [],
  onPhotoClick: () => {},
  onExpand: () => {},
  onCollapse: () => {},
  media: {},
  disableExpand: false
};
export default withMedia(PropertyHistoryCard);